import { render } from "./MemoForm.vue?vue&type=template&id=5ff9c972&scoped=true&ts=true"
import script from "./MemoForm.vue?vue&type=script&lang=ts"
export * from "./MemoForm.vue?vue&type=script&lang=ts"

import "./MemoForm.vue?vue&type=style&index=0&id=5ff9c972&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff9c972"]])

export default __exports__